<template>
    <div >
        <div class="flex alc">
            <span class="marr4 font14 ">{{$t('saleInvoicing_invoice_quantity')}}</span>
            <el-input-number class="marr4" style="max-width: 200px" @change="changenum" :controls="false" :min="0" :precision="$setPrecision.quantityPrecision"  size="mini" v-model="kpnum"></el-input-number>
            <span class="marr4 font14">{{$t('saleInvoicing_order_quantity')}}</span>
            <span class="marr4 font14 ">{{ddnum}}</span>
            <el-button class="marr4" type="text" circle  @click="gosearch" size="mini">{{$t('saleInvoicing_click_on_the_allocation_quantity')}}</el-button>
        </div>
        <!-- @selection-change="handleSelectionChange"-->
        <el-table
                border
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                row-key="uniquekey"
                @select="select"
                v-loading="loading2"
                size="mini"
                :height="tableHeight"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                :highlight-current-row="highlightCurrentRow">
            <el-table-column
                    type="selection"
                    width="55">
            </el-table-column>
            <el-table-column
                    type="index"
                    width="50">
            </el-table-column>
            <el-table-column
                    prop="i_type"
                    :label="$t('saleInvoicing_type')"
                    show-overflow-tooltip
                    width="95">
                <template slot-scope="scope">
                    <span >{{scope.row.i_type==0?$t('saleInvoicing_outbound'):(scope.row.i_type==1?$t('saleInvoicing_pre_release_from_warehouse'):(scope.row.i_type==2?$t('saleInvoicing_return_warehousing'):(scope.row.i_type==3?$t('saleInvoicing_tusun'):'')))}}</span>
                    <!-- 无4(scope.row.i_type==4?$t('saleInvoicing_jushou'):'')-->
                </template>
            </el-table-column>
            <el-table-column
                    prop="vc_pzname"
                    :label="$t('saleInvoicing_variety')"
                    show-overflow-tooltip
                    min-width="200">
            </el-table-column>
            <el-table-column
                    prop="vc_unit"
                    :label="$t('saleInvoicing_order_unit')"
                    show-overflow-tooltip
                    width="80">
            </el-table-column>
            <el-table-column
                    prop="f_bl"
                    :label="$t('saleInvoicing_proportion')"
                    show-overflow-tooltip
                    width="80"
                    align="right">
            </el-table-column>
            <el-table-column
                    prop="vc_kpunit_sell"
                    :label="$t('saleInvoicing_billing_entity')"
                    show-overflow-tooltip
                    width="80">
            </el-table-column>
            <el-table-column
                    prop="f_ordernum_ky"
                    :label="$t('saleInvoicing_order_availability')"
                    show-overflow-tooltip
                    align="right"
                    width="100">
            </el-table-column>
            <el-table-column
                    prop="f_ordernum"
                    :label="$t('saleInvoicing_the_quantity_of_this_invoicing_order')"
                    show-overflow-tooltip
                    align="right"
                    min-width="135">
            </el-table-column>
            <el-table-column
                    prop="f_invoicenum"
                    :label="$t('saleInvoicing_the_quantity_invoiced_this_time')"
                    show-overflow-tooltip
                    align="right"
                    min-width="135">
                <template slot-scope="scope">
                    <el-input-number @change="inbcfnum(tableData,scope.$index,scope.row)" :disabled="scope.row.f_invoicenum<0"  :controls="false" :precision="$setPrecision.quantityPrecision" size="mini" v-model="scope.row.f_invoicenum" ></el-input-number>
                </template>
            </el-table-column>
            <el-table-column
                    prop="f_kpprice_sell"
                    :label="$t('saleInvoicing_invoice_unit_price')"
                    show-overflow-tooltip
                    align="right">
            </el-table-column>
            <el-table-column
                    prop="f_invoice_amount"
                    :label="$t('saleInvoicing_invoice_amount')"
                    show-overflow-tooltip
                    align="right">
            </el-table-column>
            <el-table-column
                    prop="f_invoice_amount_notax"
                    :label="$t('saleInvoicing_invoice_tax_free_amount')"
                    show-overflow-tooltip
                    align="right"
                    min-width="135">
                <template slot-scope="scope">
                    <el-input-number @change="inpayws(tableData,scope.$index,scope.row)" :disabled="scope.row.f_invoice_amount_notax<0"  :controls="false" :precision="2" size="mini" v-model="scope.row.f_invoice_amount_notax" ></el-input-number>
                </template>
            </el-table-column>
            <el-table-column
                    prop="f_sl"
                    :label="$t('saleInvoicing_tax_rate')"
                    show-overflow-tooltip
                    align="right">
            </el-table-column>
            <el-table-column
                    prop="f_invoice_amount_tax"
                    :label="$t('saleInvoicing_tax_amount')"
                    show-overflow-tooltip
                    align="right"
                    min-width="135">
                <template slot-scope="scope">
                    <el-input-number @change="inpayzzs(tableData,scope.$index,scope.row)" :disabled="scope.row.f_invoice_amount_tax<0"  :controls="false" :precision="2" size="mini" v-model="scope.row.f_invoice_amount_tax" ></el-input-number>
                </template>
            </el-table-column>
            <!--<el-table-column
                    prop="f_reject_num"
                    :label="$t('saleInvoicing_rejected_quantity')"
                    show-overflow-tooltip
                    align="right">
            </el-table-column>-->
            <el-table-column
                    prop="f_ordernum_used"
                    :label="$t('saleInvoicing_number_of_invoiced_orders')"
                    show-overflow-tooltip
                    align="right"
                    width="135">
            </el-table-column>
            <el-table-column
                    prop="f_outbound_num"
                    :label="$t('saleInvoicing_outbound_quantity')"
                    show-overflow-tooltip
                    align="right">
            </el-table-column>
            <!--<el-table-column
                    prop="f_transitloss_num"
                    :label="$t('saleInvoicing_loss_in_transit')"
                    show-overflow-tooltip
                    align="right">
            </el-table-column>-->
            <el-table-column
                    prop="dt_ywtime"
                    :label="$t('saleInvoicing_business_hours')"
                    show-overflow-tooltip
                    width="130">
            </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer" style="text-align: center;padding: 6px">
            <el-button  type="primary" @click="confirm"  :class="baseerp+'btn'" size="small">{{$t('button_confirm')}}</el-button>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
        <div>
            <!--<el-pagination
                    class="flex_e padT6"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[20, 30, 50]"
                    :page-size="pageSize"
                    layout="sizes, prev, pager, next"
                    :total="tableTotal">
            </el-pagination>-->
            <!--<div class="flex_b alc">
                <div>
                    {{'已选'+ ' '+multipleSelection.length+' '+'条'}}
                </div>
                <el-button :class="baseerp+'btn'"  size="small"  @click="sure">确定</el-button>
                &lt;!&ndash;<div class="flex alc">
                    <div class="marr4">
                        <div style="color: #9e9e9e;font-size: 12px">{{'开票总额'}}</div>
                        <div>{{totalPrice}}</div>
                    </div>
                    <el-button :class="baseerp+'btn'"  size="small" type="primary">确定</el-button>
                </div>&ndash;&gt;
            </div>-->
        </div>
    </div>
</template>
<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "",
        components: {
        },
        props:{
            orderData:{
                type:Object,
                required:true,
            }
        },
        data(){
            return{
                isNeedRefresh: false,
                i_isforeign:null,
                GLxsddata:[{i_id:null,vc_name:this.$t('saleInvoicing_all')},{i_id:0,vc_name:this.$t('saleInvoicing_domestic')},{i_id:1,vc_name:this.$t('saleInvoicing_foreign_countries')}],
                i_iskp:null,
                GLdata:[{i_id:null,vc_name:this.$t('saleInvoicing_all')},{i_id:0,vc_name:this.$t('saleInvoicing_uninvoiced')},{i_id:1,vc_name:this.$t('saleInvoicing_invoiced')}],
                baseerp:"",
                mid:0,
                title:this.$t('saleInvoicing_new_invoice_issuance'),
                dialogVisible_add:false,
                dialogVisible_sheet:false,
                dialogVisible_yck:false,
                i_gsid:0,
                loading2:true,
                vc_search:"",
                highlightCurrentRow:false,
                pageSize:20,
                currentPage:1,
                tableTotal:0,
                valuetime:'',
                dt_startdate:'',
                dt_enddate:'',
                tableData: [],
                multipleSelection: [],
                multipleSelection_2:[],
                tableHeight:0,
                syddnum:0,
                ddnum:0,
                kpnum:0,
                masterSelectedList:[],
                selected:[],
                vc_unit:'',
                vc_kpunit_sell:'',
                f_bl:1,
                f_sl:0.13,
                kpvalidnum:0,
            }
        },
        created() {
            const listFromA = this.orderData.select;
            if (listFromA && Array.isArray(listFromA)) {
                listFromA.forEach(item => {
                    if (!this.masterSelectedList.find(i => i.uniquekey === item.uniquekey)) {
                        this.masterSelectedList.push(item)   // 存完整对象
                    }
                })
            }
            //console.log('this.masterSelectedList....',this.masterSelectedList)
        },
        mounted() {
            //console.log("sessionStorage.getItem('mids')",sessionStorage.getItem('mids'))
            this.baseerp=baseerp;
            //console.log('data',this.orderData);
            this.kpnum=this.orderData.kpnum;
            this.ddnum=(this.orderData.kpnum/this.orderData.f_bl).toFixed(this.$setPrecision.quantityPrecision);
            this.selected = this.orderData.select;
            this.vc_unit=this.orderData.vc_unit;
            this.vc_kpunit_sell=this.orderData.vc_kpunit_sell;
            this.f_kpprice_sell=this.orderData.f_kpprice_sell;
            this.kpvalidnum=(this.orderData.validnum*this.orderData.f_bl).toFixed(this.$setPrecision.quantityPrecision);
            //console.log(this.kpvalidnum,'this.kpvalidnum')
            this.f_bl=this.orderData.f_bl;
            this.getList();
            //this.getfMou();

        },
        beforeDestroy() {
            window.removeEventListener('resize', this.updateTableHeight);
        },
        methods:{
            updateTableHeight() {
                //console.log(this.Data.maxDialogHeight,'this.Data.maxDialogHeight');
                const dialogHeight = this.orderData.maxDialogHeight; // 弹窗最大高度
                //console.log(dialogHeight,' dialogHeight');
                const otherHeight =450;
                this.tableHeight = dialogHeight - otherHeight;
                //this.tableHeight = 400;
                //console.log( this.tableHeight,' this.tableHeight')
                this.maxDialogHeight =  this.orderData.maxDialogHeight;
            },
            changeselT(){
                const total = this.masterSelectedList.reduce((sum, row) => {
                    const num = parseFloat(row.f_invoicenum) || 0;
                    return sum + num;
                }, 0);
                this.syddnum = ( parseFloat(this.kpnum) - total).toFixed(this.$setPrecision.quantityPrecision)>0?( parseFloat(this.kpnum) - total).toFixed(this.$setPrecision.quantityPrecision):0;
                //console.log('syddnum:', this.syddnum);
            },
            inbcfnum(data,index,row){
                const lineLimit = parseFloat((row.f_ordernum_ky*this.f_bl).toFixed(this.$setPrecision.quantityPrecision));
                const selectedRows = this.$refs.multipleTable.selection;
                const otherSelectedTotal = selectedRows
                    .filter(item => item.uniquekey !== row.uniquekey)
                    .reduce((sum, item) => sum + parseFloat(item.f_invoicenum || 0), 0);
                const currentMaxAllowed = parseFloat(this.kpnum) - otherSelectedTotal;
                //console.log(currentMaxAllowed,'currentMaxAllowed',lineLimit,'lineLimit')
                const absoluteMax = Math.min(lineLimit, currentMaxAllowed);
                if ((row.f_invoicenum > absoluteMax + 0.0000001) || (row.f_invoicenum<=0)) {
                    this.$message.error(this.$t('saleInvoicing_maximum_available')+`：${absoluteMax.toFixed(this.$setPrecision.quantityPrecision)}`);

                    this.$nextTick(() => {
                        row.f_invoicenum = absoluteMax.toFixed(this.$setPrecision.quantityPrecision);
                        row.f_ordernum = (row.f_invoicenum / this.f_bl).toFixed(this.$setPrecision.quantityPrecision);
                        row.f_invoice_amount=parseFloat(this.keepTwoDecimal(row.f_invoicenum*row.f_kpprice_sell));
                        row.f_invoice_amount_notax=parseFloat(this.keepTwoDecimal(this.preciseDiv(row.f_invoice_amount, parseFloat(1+row.f_sl))));
                        row.f_invoice_amount_tax=parseFloat(this.keepTwoDecimal(row.f_invoice_amount_notax*row.f_sl));
                        this.$set(data,index,row);
                        this.changeselT();
                    });
                    return;
                }
                row.f_ordernum=(row.f_invoicenum/this.f_bl).toFixed(this.$setPrecision.quantityPrecision);
                row.f_invoice_amount=parseFloat(this.keepTwoDecimal(row.f_invoicenum*row.f_kpprice_sell));
                row.f_invoice_amount_notax=parseFloat(this.keepTwoDecimal(this.preciseDiv(row.f_invoice_amount, parseFloat(1+row.f_sl))));
                row.f_invoice_amount_tax=parseFloat(this.keepTwoDecimal(row.f_invoice_amount_notax*row.f_sl));
                this.$set(data,index,row);
                const idx = this.masterSelectedList.findIndex(item => item.uniquekey === row.uniquekey);
                if (idx >= 0) this.$set(this.masterSelectedList, idx, { ...row });
                this.changeselT();


            },
            inpayws(data, index, row,event) {
                let cenzzs = this.preciseDiv(row.f_invoice_amount, parseFloat(1+row.f_sl));
                cenzzs = parseFloat(this.keepTwoDecimal(cenzzs));
                let more = cenzzs + 1;
                let less = cenzzs - 1;
                //console.log(cenzzs,row.f_invoice_amount_notax,'111')
                if (row.f_invoice_amount_notax < less || row.f_invoice_amount_notax > more) {
                    this.$message.error(this.$t('invoiceEntry_the_tax-free_price_must_not_exceed_or_fall_short_of_the_set_price_by_more_than') + cenzzs + "±1！！");

                    this.$nextTick(() => {
                        row.f_invoice_amount_notax = cenzzs;
                        let fzzs = row.f_invoice_amount_notax * row.f_sl;
                        row.f_invoice_amount_tax = parseFloat(this.keepTwoDecimal(fzzs));
                        this.$set(data,index,row);
                        this.changeselT();
                    });
                    return;
                }
                let fzzs = row.f_invoice_amount_notax * row.f_sl;
                row.f_invoice_amount_tax = parseFloat(this.keepTwoDecimal(fzzs));
                this.$set(data,index,row);
                const idx = this.masterSelectedList.findIndex(item => item.uniquekey === row.uniquekey);
                if (idx >= 0) this.$set(this.masterSelectedList, idx, { ...row });
                this.changeselT();

            },
            inpayzzs(data, index, row , event) {
                let cenzzs = row.f_invoice_amount_notax * row.f_sl;
                cenzzs = parseFloat(this.keepTwoDecimal(cenzzs));
                let more = cenzzs + 1;
                let less = cenzzs - 1;
                if (row.f_invoice_amount_tax < less || row.f_invoice_amount_tax > more) {
                    this.$message.error(this.$t('invoiceEntry_the_tax_amount_must_not_exceed_or_be_less_than_the_established_tax_amount_by_more_than') + cenzzs + "±1！");
                    //if (event && event.target && typeof event.target.blur === 'function') {
                    //    event.target.blur();
                    //}
                    this.$nextTick(() => {

                        row.f_invoice_amount_tax = cenzzs;
                        this.$set(data,index,row);
                        const idx = this.masterSelectedList.findIndex(item => item.uniquekey === row.uniquekey);
                        if (idx >= 0) this.$set(this.masterSelectedList, idx, { ...row });
                        this.changeselT();
                    });
                    return;
                }
                this.$set(data,index,row);
                const idx = this.masterSelectedList.findIndex(item => item.uniquekey === row.uniquekey);
                if (idx >= 0) this.$set(this.masterSelectedList, idx, { ...row });
                this.changeselT();
            },

            changenum(e){
                //console.log(e,'e')
                if(e>this.kpvalidnum){
                    this.$message.error(this.$t('saleInvoicing_the_invoiced_quantity_cannot_exceed_the_quantity_to_be_invoiced')+this.kpvalidnum+'!');
                    this.$nextTick(() => {
                        this.kpnum=this.kpvalidnum;
                        this.ddnum=(this.kpnum/this.orderData.f_bl).toFixed(this.$setPrecision.quantityPrecision);
                    });
                    return;
                }
                this.kpnum=e;
                this.ddnum=(this.kpnum/this.orderData.f_bl).toFixed(this.$setPrecision.quantityPrecision);
            },
            confirm(){
                //console.log(this.masterSelectedList,'confirm')
                const total = this.masterSelectedList.reduce((sum, row) => {
                    const num = parseFloat(row.f_invoicenum) || 0;
                    return sum + num;
                }, 0);
                //console.log('total:', total);
                if (total.toFixed(this.$setPrecision.quantityPrecision) !== parseFloat(this.kpnum).toFixed(this.$setPrecision.quantityPrecision)) {
                    this.$message.error(this.$t('saleInvoicing_the_total_quantity_invoiced_this_time_is_inconsistent_with_the_invoiced_quantity'));
                    return;
                }
                let arr = [];
                arr = this.masterSelectedList.map(row=>{
                    return {
                        i_ywid:row.i_id,
                        f_ordernum:row.f_ordernum,
                        f_invoicenum:row.f_invoicenum,
                        i_type:row.i_type,
                        dt_ywtime:row.dt_ywtime,
                        uniquekey:row.uniquekey,
                        f_transitloss_num:row.f_transitloss_num,
                        f_reject_num:row.f_reject_num,
                        f_outbound_num:row.f_outbound_num,
                        f_invoice_amount:row.f_invoice_amount,
                        f_invoice_amount_notax:row.f_invoice_amount_notax,
                        f_invoice_amount_tax:row.f_invoice_amount_tax,
                        f_order_amount:row.f_invoice_amount,
                        f_order_amount_notax:row.f_invoice_amount_notax,
                        f_order_amount_tax:row.f_invoice_amount_tax,
                    }
                })
                this.$emit('close', arr , this.kpnum)
            },
            cancel(){
                this.$emit('close', this.orderData.select.length==0?[]:this.masterSelectedList , this.kpnum)
            },
            uniqueByKey(arr, key) {
                let seen = new Set();
                return arr.filter((item) => {
                    let keyValue = item[key];
                    if (seen.has(keyValue)) {
                        return false;
                    } else {
                        seen.add(keyValue);
                        return true;
                    }
                });
            },
            sure(){
                /*console.log(this.multipleSelection,'this.multipleSelection');
                console.log(this.multipleSelection_2,'this.multipleSelection_2');
                let uniqueItems = this.uniqueByKey(this.multipleSelection_2, 'uniquekey');
                console.log('uniqueItems',uniqueItems);
                this.$emit('cancelDialog',uniqueItems)*/
            },
            handleSelectionChange(val) {
                //console.log(val,'val')
                /*this.multipleSelection = val;
                this.multipleSelection_2 = [...this.multipleSelection_2 , ...val];*/
            },
            select(val,row){
                //console.log(row,'row')
                const isSelected = val.some(item => item.uniquekey === row.uniquekey);
                if(isSelected){
                    //const cfcz = this.deletedIds.some(item => item === row.i_id);
                    //if(cfcz){
                    //    row.i_id=0;
                    //}
                    if(this.syddnum>0){
                        const kykpnum = parseFloat((row.f_ordernum_ky*this.f_bl).toFixed(this.$setPrecision.quantityPrecision));
                        //console.log('kykpnum',kykpnum)
                        if(parseFloat(this.syddnum) <= kykpnum){
                            row.f_invoicenum = this.syddnum
                            //console.log(' row.f_invoicenum1', row.f_invoicenum)
                        }else{
                            //row.f_invoicenum = row.f_ordernum_ky
                            row.f_invoicenum = kykpnum
                            //console.log(' row.f_invoicenum2', row.f_invoicenum)
                        }

                    }else{
                        row.f_invoicenum = 0
                    }
                    //row.f_invoicenum=this.syddnum>0?this.syddnum:0
                    row.f_invoicenum_ky=row.f_invoicenum
                    row.f_ordernum=(row.f_invoicenum/this.f_bl).toFixed(this.$setPrecision.quantityPrecision);

                    //this.multipleSelection = val;
                    if (!this.masterSelectedList.some(item => item.uniquekey === row.uniquekey)&&this.syddnum!=0) {
                        this.masterSelectedList.push({ ...row });
                    }
                }else{
                    // 负数不允许取消勾选
                    if (parseFloat(row.f_invoicenum || 0) < 0) {
                        this.$message.error('负数金额不允许取消勾选');
                        // 恢复勾选状态
                        this.$nextTick(() => {
                            this.$refs.multipleTable.toggleRowSelection(row, true);
                        });
                        return;
                    }
                    const exists = this.selected.some(item => item.uniquekey === row.uniquekey);
                    row.f_ordernum=0;
                    row.f_invoicenum=0;
                    row.f_invoicenum_ky=0;
                    //if(exists){
                    //    if(row.i_id!=0){
                    //        this.deletedIds.push(row.i_id);
                    //    }
                    //}
                    //this.multipleSelection = val;
                    this.masterSelectedList = this.masterSelectedList.filter(item => item.uniquekey !== row.uniquekey);
                    this.changeselT();
                }
            },
            gosearch(){
                this.handleAllocation(this.ddnum,this.f_sl)
            },
            /*handleSizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                this.getList();
            },*/
            /*handleCurrentChange(val){
                this.currentPage=val;
                this.getList();
            },*/
            //列表list
            async getList(){
                this.loading2=true;
                let arr=[];
                arr.push(this.orderData.map);
                let param={
                    'i_mid':this.mid,
                    "queryList":arr,
                    'i_order_source':this.orderData.i_order_source
                };
                var res = await API.getRelateOrderDetailList(param);
                /*let param={
                    'i_mid':this.mid,
                    "i_gsid": 1001,
                    "vc_search": '',
                    "currentPage":1,
                    "pageSize": 20,
                    'dt_enddate': "2026-04-22",
                    'dt_startdate': "2026-04-01",
                };
                var res = await API.listBeforeInvoice(param);*/
                if (res.code==1){
                    //this.tableData=res.data.list;
                    this.tableData=res.data[0].subDetails;
                    this.f_sl=res.data[0].f_sl;
                    this.loading2=false;
                    if(this.orderData.select.length==0){
                        this.handleAllocation(this.ddnum,this.f_sl)
                    }else{
                        this.tableData.forEach(row => {
                            row.f_invoicenum=0;
                            row.f_ordernum=0;
                            row.vc_unit=this.vc_unit;
                            row.vc_kpunit_sell=this.vc_kpunit_sell;
                            row.f_bl=this.f_bl;
                            row.f_sl=this.f_sl;
                            row.f_kpprice_sell=this.f_kpprice_sell;
                            row.f_invoice_amount=0;
                            row.f_invoice_amount_notax=0;
                            row.f_invoice_amount_tax=0;
                            this.$nextTick(()=>{
                                const isSelected = this.masterSelectedList.some(sel => sel.uniquekey == row.uniquekey);
                                //console.log(isSelected,'isSelected')
                                this.$refs.multipleTable.toggleRowSelection(row, isSelected);
                                const idx = this.masterSelectedList.findIndex(i => i.uniquekey === row.uniquekey);
                                if (idx !== -1 && isSelected) {
                                    row.f_ordernum=this.masterSelectedList[idx].f_ordernum
                                    row.f_invoicenum=this.masterSelectedList[idx].f_invoicenum
                                    row.f_invoice_amount=parseFloat(this.keepTwoDecimal(row.f_invoicenum*row.f_kpprice_sell));
                                    row.f_invoice_amount_notax=parseFloat(this.keepTwoDecimal(this.preciseDiv(row.f_invoice_amount, parseFloat(1+row.f_sl))));
                                    row.f_invoice_amount_tax=parseFloat(this.keepTwoDecimal(row.f_invoice_amount_notax*row.f_sl));
                                    row.f_invoicenum_ky=(row.f_ordernum*this.f_bl).toFixed(this.$setPrecision.quantityPrecision);
                                    this.$set(this.masterSelectedList, idx, { ...row, ...this.masterSelectedList[idx] })
                                }
                            })
                        });

                    }
                    this.updateTableHeight();
                    window.addEventListener('resize', this.updateTableHeight);
                    // console.log('this.multipleSelection_2',this.multipleSelection_2)
                }else if (res.code == -2) {
                    this.loading2=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading2=false;
                    this.$message.error(res.message);
                }
            },

            handleAllocation(ddnum,sl) {
                //console.log('ddnum',ddnum,sl,'sl')
                //console.log('this.$setPrecision.quantityPrecision',this.$setPrecision.quantityPrecision)
                this.loading2=true;
                let remaining = parseFloat(ddnum) || 0;
                this.$refs.multipleTable.clearSelection();
                this.masterSelectedList=[];
                this.tableData.forEach(row => {
                    row.f_invoicenum=0;
                    row.f_ordernum=0;
                    row.vc_unit=this.vc_unit;
                    row.vc_kpunit_sell=this.vc_kpunit_sell;
                    row.f_bl=this.f_bl;
                    row.f_sl=sl;
                    row.f_kpprice_sell=this.f_kpprice_sell;
                    row.f_invoice_amount=0;
                    row.f_invoice_amount_notax=0;
                    row.f_invoice_amount_tax=0;
                    const maxAvailable = parseFloat(row.f_ordernum_ky) || 0; // 当前行最大可关联量
                    let currentAllocated = 0;
                    if (remaining > 0) {
                        if (remaining >= maxAvailable) {
                            currentAllocated = maxAvailable;
                            remaining = parseFloat((remaining - maxAvailable).toFixed(this.$setPrecision.quantityPrecision));
                        } else {
                            currentAllocated = remaining;
                            remaining = 0;
                        }
                        row.f_ordernum = currentAllocated.toFixed(this.$setPrecision.quantityPrecision);
                        row.f_invoicenum = parseFloat((row.f_ordernum*this.orderData.f_bl).toFixed(this.$setPrecision.quantityPrecision));
                        row.f_invoicenum_ky=parseFloat((row.f_ordernum*this.f_bl).toFixed(this.$setPrecision.quantityPrecision));
                        row.f_invoice_amount=parseFloat(this.keepTwoDecimal(row.f_invoicenum*row.f_kpprice_sell));
                        row.f_invoice_amount_notax=parseFloat(this.keepTwoDecimal(this.preciseDiv(row.f_invoice_amount, parseFloat(1+row.f_sl))));
                        row.f_invoice_amount_tax=parseFloat(this.keepTwoDecimal(row.f_invoice_amount_notax*row.f_sl));

                        this.$nextTick(() => {
                            this.$refs.multipleTable.toggleRowSelection(row, true);
                            this.masterSelectedList.push({ ...row });
                        });
                    } else {
                        row.f_ordernum =  0;
                        row.f_invoicenum = 0;
                        row.f_invoicenum_ky=0;
                        row.f_invoice_amount=0;
                        row.f_invoice_amount_notax=0;
                        row.f_invoice_amount_tax=0;
                    }
                    //console.log('this.tableData',this.tableData)
                });
                this.loading2=false;
                this.$nextTick(()=>{
                    //console.log('this.masterSelectedList',this.masterSelectedList)
                    const total = this.masterSelectedList.reduce((sum, row) => {
                        const num = parseFloat(row.f_invoicenum_ky) || 0;
                        return sum + num;
                    }, 0);
                    //console.log(parseFloat(this.kpnum), '-', total,parseFloat(this.kpnum) - total)
                    this.syddnum = ( parseFloat(this.kpnum) - total).toFixed(this.$setPrecision.quantityPrecision)>0?( parseFloat(this.kpnum) - total).toFixed(this.$setPrecision.quantityPrecision):0;
                    //console.log('syddnum:', this.syddnum);
                });

            } ,
            keepTwoDecimal(num) {
                const parsed = parseFloat(num);
                if (isNaN(parsed)) return 0;
                return Number(parsed.toFixed(2));
            },
            //除
            preciseDiv(dividend, divisor) {
                if (dividend && divisor) {
                    //console.log(dividend, "////", divisor);
                    // 将除数和被除数转换为整数
                    const intDividend = parseFloat(dividend * 1000);
                    const intDivisor = parseFloat(divisor * 1000);
                    // 执行除法
                    const result = intDividend / intDivisor;
                    //console.log(result, 'result------')
                    return result;
                }
            },
            //获取当前月的第一天
            getfMou(){
                let today = new Date();
                let firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
                // console.log(firstDay,today);
                let map = [firstDay,today];
                this.valuetime=map;
                // console.log(this.valuetime)
                this.dt_startdate= this.formatDate( this.valuetime[0]);
                this.dt_enddate= this.formatDate( this.valuetime[1]);
                this.getList();
            },
            formatTen(num) {
                return num > 9 ? (num + "") : ("0" + num);
            },
            formatDate(date) {
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var minute = date.getMinutes();
                var second = date.getSeconds();
                return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
            },
            getTimes(e){
                // console.log(e)
                if(e){
                    this.dt_startdate= this.formatDate(e[0]);
                    this.dt_enddate= this.formatDate(e[1]);
                    // console.log(this.dt_startdate,this.dt_enddate);
                }else{
                    this.dt_startdate= '';
                    this.dt_enddate= '';
                }
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },



        },
    }
</script>


<style  lang="scss" scoped>
    /deep/.el-table td{

    }
    .green{
        background-color: green !important;
    }
    .boxyu{
        background-color: #fa5050;
        border-radius: 4px;
        padding: 1px 4px;
        color: #fff;
        font-size: 14px;
    }
    .boxbu{
        width: 38px;
        height: 28px;
        line-height: 25px;
    }
    .box{
        width: 24px;
        height: 24px;
        line-height: 24px;
    }
    .cgdia {
        //弹出层里内容 样式
        /deep/.el-dialog__body {
            max-height: 85vh !important;
            overflow-y: auto;
            padding: 6px !important;
        }

    }

    .flex_e{
        display: flex;
        justify-content: end;
    }
    .mar9{
        margin: 9px;
    }
    .alc{
        align-items: center;
    }
    .flex{
        display: flex;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .fr{
        float: right;
    }
    .mrr9{
        margin-right: 9px;
    }
    .padT6{
        //padding: 6px 0;
    }
    .pad14{
        padding: 6px;
    }
    .w100{
        width: 100%;
    }
    .marr4{
        margin-right: 10px;
    }
    .subitem{
        flex:  1;
    }


</style>
